import {ConfigService, ErrorsService, PoiCategory, ModelsList, StoreService, Poi} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class PoiCategoryService extends StoreService<PoiCategory> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(PoiCategory);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<PoiCategory>> {
    return this.http.get<ModelsList<PoiCategory>>(this.config.apiVerUrl('/app/poi-categories'), {params: queryParams});
  }

  protected insert(values: PoiCategory): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/poi-categories'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/poi-categories/${id}`));
  }

  protected update(id, values: PoiCategory): Observable<PoiCategory> {
    return this.http.put<PoiCategory>(this.config.apiVerUrl(`/app/poi-categories/${id}`), values);
  }

  byKey(id): Observable<PoiCategory> {
    return this.http.get<PoiCategory>(this.config.apiVerUrl(`/app/poi-categories/${id}`))
      .pipe(map(c => new PoiCategory(c)));
  }
}
